var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('b-col',{staticClass:"j-end align-start",attrs:{"cols":"12","lg":"6"}},[_c('vuelto-efectivo'),_c('btn-loader',{staticClass:"venta-total-box",attrs:{"disabled":_vm.loader,"icon":"check","text":_vm.text_btn,"loader":_vm.loader,"dusk":"btn_vender"},on:{"clicked":_vm.saveSale}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }